import { Close as CloseIcon } from "@mui/icons-material"
import { IconButton, IconButtonProps } from "@mui/material"
import styled from "styled-components"

const StyledCloseButton = styled(IconButton)`
  position: absolute;
  top: 0;
  right: 0;
  :focus {
    color: ${(p) => p.theme.colors.black};
  }
`

const CloseButton = (props: IconButtonProps) => (
  <StyledCloseButton aria-label="close" {...props}>
    <CloseIcon />
  </StyledCloseButton>
)

export default CloseButton
